import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSlashIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.3125 12C19.3125 16.0386 16.0386 19.3125 12 19.3125C7.96142 19.3125 4.6875 16.0386 4.6875 12C4.6875 7.96142 7.96142 4.6875 12 4.6875C16.0386 4.6875 19.3125 7.96142 19.3125 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02943 21 3 16.9706 3 12C3 7.02943 7.02943 3 12 3C16.9706 3 21 7.02943 21 12ZM9.22162 8.02838L8.625 7.43176L7.43176 8.625L8.02838 9.22162L14.7784 15.9716L15.375 16.5683L16.5683 15.375L15.9716 14.7784L9.22162 8.02838Z",
		fill: "currentColor"
	})
});
export default SvgSlashIcon;
